import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreConstants } from 'src/app/shared/models/store.model';
import * as ServiceVanReducers from './reducer';
import { ServiceVanState } from './reducer';
import { ServiceVanCardInfoSto, ServiceVanMasterDataSto } from '../models/servicevan.model.sto';

export const getServiceVansState = createFeatureSelector<ServiceVanState>(StoreConstants.FEATURE_STORE_SERVICEVANS);

export const getPageResult = createSelector(getServiceVansState, ServiceVanReducers.pageResult);

const pageLoadingState = createSelector(getServiceVansState, ServiceVanReducers.pageLoading);

export const getPageLoading = (viewId: string) =>
  createSelector(pageLoadingState, (loadingState: Map<string, boolean>) => {
    if (!loadingState || !loadingState[viewId]) return false;

    return loadingState[viewId];
  });

export const getServiceVansList = createSelector(getServiceVansState, ServiceVanReducers.serviceVans);

export const getServiceVansLoadedAt = createSelector(getServiceVansState, ServiceVanReducers.serviceVansLoadedAt);

export const getServiceVanCardsInfo = createSelector(getServiceVansList, serviceVans => {
  return serviceVans.map((serviceVan: ServiceVanMasterDataSto) => {
    return new ServiceVanCardInfoSto(serviceVan);
  });
});

export const getServiceVanMasterData = (serviceVanId: string) =>
  createSelector(getServiceVansList, (serviceVans: ServiceVanMasterDataSto[]) => {
    return serviceVans.filter(van => van.aggregateId === serviceVanId).shift();
  });

const getServiceVanDetailsMap = createSelector(getServiceVansState, ServiceVanReducers.detailsResult);

export const getServiceVanDetails = (aggregateId: string) =>
  createSelector(getServiceVanDetailsMap, (map: Map<string, ServiceVanReducers.ServiceVanDetailsResultEntry>) => {
    if (!aggregateId || !map[aggregateId]) return null;
    return map[aggregateId];
  });

const getServiceVanDetailsLoadedAtMap = createSelector(getServiceVansState, ServiceVanReducers.detailsLoadedAt);

export const getServiceVanDetailsLoadedAt = (aggregateId: string) =>
  createSelector(getServiceVanDetailsLoadedAtMap, (loadedAt: Map<string, Date>) => {
    if (!aggregateId || !loadedAt[aggregateId]) return null;
    return loadedAt[aggregateId];
  });

const getServiceVanDetailsLoadingMap = createSelector(getServiceVansState, ServiceVanReducers.detailsLoading);

export const getServiceVanDetailsLoading = (aggregateId: string) =>
  createSelector(getServiceVanDetailsLoadingMap, (loading: Map<string, boolean>) => {
    if (!aggregateId || !loading[aggregateId]) return false;
    return loading[aggregateId];
  });

export const getServiceVanAvatarImage = (_serviceVanId: string) =>
  createSelector(getServiceVansList, (_serviceVans: ServiceVanMasterDataSto[]) => {
    return null;
  });
